import Container from '../../../elements/Container'
import Section from '../../../elements/Section'
import IconNewsletter from '/public/icons/icon-newslsetter.svg'
import Form from '../../../general/Footer/components/Form'
import styles from './styles.module.scss'

const Subscribe = ({
  variant = ['white'],
  title,
  description,
  translations
}) => (
  <Section
    separator={variant.includes('separator')}
    variant={['center', ...variant]}
  >
    <Container variant={['-xs5']}>
      <IconNewsletter />
      {title && <h2>{title}</h2>}

      <Form translations={translations} variant={['large', 'mobile-full']} />

      {description && <span className={styles.label}>{description}</span>}
    </Container>
  </Section>
)

export default Subscribe
